<template>
  <div>
    <div class="line-chart" v-loading="query.loading">
      <div style="display: flex;padding: 10px 0 0 10px;align-items: center" >
        <div style="margin-right: 10px">交易趋势</div>
        <el-select v-model="query.mchIds" placeholder="请选择" style="width: 260px" multiple collapse-tags @change="recordMonthSummary">
          <el-option
              v-for="item in merchantList"
              :key="item.mchId"
              :label="item.mchName"
              :value="item.mchId"
          />
        </el-select>
        <el-date-picker style="width: 140px;margin: 0 10px" v-model="query.yearMonth" @change="recordMonthSummary"
                        type="month" format="YYYY-MM" value-format="YYYY-MM" placeholder="请选择"/>
      </div>
      <div style="display:flex;font-weight: bold;justify-content: space-between">
        <div class="total">
          <div style="font-size: 15px;margin-bottom: 6px">{{lineChartData.totalCount}}</div>
          <div>总单量</div>
        </div>
        <div class="total">
          <div style="font-size: 15px;margin-bottom: 6px">{{lineChartData.totalMoney}}</div>
          <div>总金额</div>
        </div>

        <div class="total">
          <div style="font-size: 15px;margin-bottom: 6px">{{lineChartData.normalMoney/100}}</div>
          <div>正常金额</div>
        </div>
        <div class="total">
          <div style="font-size: 15px;margin-bottom: 6px">{{lineChartData.noCheckMoney/100}}</div>
          <div>未对账金额</div>
        </div>
        <div class="total">
          <div style="font-size: 15px;margin-bottom: 6px">{{lineChartData.abnormalMoney/100}}</div>
          <div>对账异常金额</div>
        </div>
        <div class="total">
          <div style="font-size: 15px;margin-bottom: 6px">{{lineChartData.confiscateMoney/100}}</div>
          <div>充公金额</div>
        </div>

      </div>
      <div id="mainss" ref="lineColumnar" style="width: 100%;height: 440px"></div>
    </div>
    <div style="padding: 10px 10px">
      <div style="display: flex;align-items: center;margin-bottom: 10px;">
        <div>
          <el-select v-model="tableQuery.mchIds" placeholder="请选择" style="width: 260px" multiple collapse-tags @change="selectTableData">
            <el-option
                v-for="item in merchantList"
                :key="item.mchId"
                :label="item.mchName"
                :value="item.mchId"
            />
          </el-select>
          <el-select v-model="tableQuery.checkState" placeholder="请选择" style="width: 140px;margin-left: 10px" @change="selectTableData">
            <el-option label="未对账" value="0"/>
            <el-option label="正常" value="1"/>
            <el-option label="金额异常" value="2"/>
          </el-select>
          <el-date-picker @change="selectTableData"
                          style="width: 340px;margin:0 10px"
                          v-model="tableQuery.totalDate"
                          type="datetimerange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          format="YYYY-MM-DD HH:mm:ss"
                          date-format="YYYY-MM-DD"
                          time-format="HH:mm:ss"
                          value-format="YYYY-MM-DD HH:mm:ss"/>
        </div>
        <el-button type="primary" style="margin: 0" @click="selectTableData">查询</el-button>
        <el-button type="primary" style="margin: 0" @click="excelMerchantList">导出</el-button>
      </div>

      <el-table :data="tableData" style="width: 100%" border class="table" height="446px"  v-loading="tableData.loading">
        <el-table-column prop="id" label="交易Id" align="left" width="80" show-overflow-tooltip/>
        <el-table-column prop="mchId" label="商户Id" width="140" align="left" show-overflow-tooltip/>
        <el-table-column prop="mchName" label="商户名称" align="left" show-overflow-tooltip/>
        <el-table-column prop="transactionId" label="商户单号" align="left"  show-overflow-tooltip/>
        <el-table-column prop="outTransactionId" label="交易单号" align="left" show-overflow-tooltip/>
        <el-table-column prop="outTradeNo" label="订单号" align="left" show-overflow-tooltip/>
        <el-table-column prop="totalFee" label="金额" align="left" width="100" show-overflow-tooltip>
          <template #default="scope">￥{{ scope.row.totalFee/100 }}</template>
        </el-table-column>
        <el-table-column label="对账状态" width="120" align="left" show-overflow-tooltip >
          <template #default="scope">
            <el-button type="primary" style="margin: 0" @click="openTradingRecord(scope.row)">{{ scope.row.checkState}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="gmtPayment" label="支付时间" align="left" width="140" show-overflow-tooltip>
          <template #default="scope">
            <el-tooltip class="box-item" effect="dark" placement="top">
              <template #content>{{'支付开始时间：'+scope.row.gmtPayment}}<br />{{ '支付结束时间：'+scope.row.timeEnd}}</template>
              {{ scope.row.timeEnd }}
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="110" fixed="right" align="center">
          <template #default="scope">
            <el-button
                type="text"
                @click="handNoAccountReminder(scope.row)"
            >提醒
            </el-button>
            <el-button
                type="text"
                @click="confiscate(scope.row)"
            >充公
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: space-between; margin-top: 16px;align-items: center">
        <div style="font-size: 14px;margin-right: 20px;color: red;">未对账总金额：{{tableQuery.noCheckMoney/100}}</div>
        <div style="font-size: 14px;margin-right: 20px;color: red;">正常总金额：{{tableQuery.normalMoney/100}}</div>
        <div style="font-size: 14px;margin-right: 20px;color: red;">对账异常总金额：{{tableQuery.abnormalMoney/100}}</div>
        <div style="font-size: 14px;margin-right: 20px;color: red;">充公金额：{{tableQuery.confiscateMoney/100}}</div>
        <div style="font-size: 14px;margin-right: 20px;color: red;">共计：{{tableQuery.totalCount}}单、￥{{tableQuery.totalMoney}}</div>
        <el-pagination
            v-model:current-page="tableQuery.pageIndex"
            v-model:page-size="tableQuery.pageSize"
            :page-sizes="[10, 20, 40, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableQuery.total"
            @size-change="changePagesSize"
            @current-change="changePages"/>
      </div>
    </div>
    <el-dialog
        v-model="tradingDialog"
        title="订单列表"
        width="1600">
      <trading-record style="margin-top: -20px" ref="trading" />
    </el-dialog>
  </div>
</template>

<script>
import {recordMonthSummary,selectMerchantList,excelMerchantList,selectMerchant,confiscate,handNoAccountReminder} from "../../api/pay/merchant";
const echarts = require('echarts/lib/echarts');
require('echarts/lib/component/toolbox');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/grid');
require('echarts/lib/component/legend');
require('echarts/lib/chart/bar');
require('echarts/lib/chart/line');
import TradingRecord from "./TradingRecord";
export default {
  name: "SonMerchant",
  components: {
    TradingRecord
  },
  data() {
    return {
      tradingDialog:false,
      merchant:null,
      regionList:[],
      query:{
        mchIds:[],
        year:null,
        month:null,
        yearMonth:null,
        loading:false,
        checkState:null
      },
      tableData:[],
      tableQuery:{
        loading:false,
        totalDate:[],
        endTime: "",
        mchIds: [],
        pageIndex: 1,
        pageSize: 10,
        startTime: "",
        total:0,
        totalMoney:0,
        totalCount:0,
        noCheckMoney:0,
        normalMoney:0,
        abnormalMoney:0,
        confiscateMoney:0
      },
      lineChartData:{
        day:[],
        count:[],
        money:[],
        totalCount: 0,
        totalMoney: 0,
        noCheckMoney:0,
        normalMoney:0,
        abnormalMoney:0,
        confiscateMoney:0
      },
      merchantList:[]
    }
  },
  created() {
    const item = this.$route.query.item;
    this.merchant = JSON.parse(item);
    this.tableQuery.mchIds = [this.merchant.mchId];
    this.query.mchIds = [this.merchant.mchId];
    selectMerchant({}).then(val=>{
      if (val.code === 200) {
        this.merchantList = val.data.vo;
        console.log(this.merchantList)
      }
    })
    this.selectTableData();
    // 获取传递的参数
    this.recordMonthSummary();
  },
  mounted() {

  },
  methods:{
    handNoAccountReminder(item){
      if (item.checkState != "未对账"){
        this.$message.error(item.checkState+"状态不允许提醒，仅支持未对账提醒！");
        return;
      }
      this.$confirm("确定在企业微信群中提醒吗? ", {
        type: "warning"
      }).then(() => {
        handNoAccountReminder(item).then(val=>{
          if (val.code == 200) {
            this.$message.success("提醒成功！");
            this.selectTableData();
          } else {
            this.$message.error("提醒失败");
          }
        })
      }).catch(() => {
      });
    },
    confiscate(item){
      this.$confirm("确定进行对账吗? ", {
        type: "warning"
      }).then(() => {
        confiscate(item).then(val=>{
          if (val.code == 200) {
            this.$message.success("充公成功！");
            this.selectTableData();
          } else {
            this.$message.error("充公失败");
          }
        })
      }).catch(() => {
      });
    },
    openTradingRecord(item){
      if (item.checkState === "充公"){
        this.$message.error("充公支付记录不允许对账！");
        return;
      }
      this.tradingDialog = true;
      setTimeout(() => {
        this.$refs.trading.dialog(item);
      }, 500);
    },
    excelMerchantList(){
      if (this.tableQuery.totalDate && this.tableQuery.totalDate.length>0){
        this.tableQuery.startTime = this.tableQuery.totalDate[0];
        this.tableQuery.endTime = this.tableQuery.totalDate[1];
        const startDate = new Date(this.tableQuery.startTime);
        const endDate = new Date(this.tableQuery.endTime);
        const timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
        const dayDiff = Math.floor(timeDiff / (24 * 60 * 60 * 1000));
        if (dayDiff>90){
          this.$message.warning("仅可下载90天内的交易记录！");
          return;
        }
      }else {
        this.$message.warning("请选择日期后进行导出！");
        return;
      }
      excelMerchantList(this.tableQuery);
      this.$message.success("导出中，请注意右上角下载按钮！");
    },

    changePages(val){
      this.tableQuery.pageIndex = val;
      this.selectTableData();
    },
    changePagesSize(val){
      this.tableQuery.pageIndex = 1;
      this.tableQuery.pageSize = val;
      this.selectTableData();
    },
    selectTableData(){
      this.tableQuery.loading = true;
      if (this.tableQuery.totalDate && this.tableQuery.totalDate.length>0){
        this.tableQuery.startTime = this.tableQuery.totalDate[0]
        this.tableQuery.endTime = this.tableQuery.totalDate[1]
      }else {
        this.tableQuery.startTime = null
        this.tableQuery.endTime = null
      }
      selectMerchantList(this.tableQuery).then(val=>{
        this.tableQuery.loading = false;
        if (val.code === 200) {
          if (val.data.payCount && val.data.payCount>0){
            this.tableQuery.noCheckMoney = val.data.noCheckMoney;
            this.tableQuery.normalMoney = val.data.normalMoney;
            this.tableQuery.abnormalMoney = val.data.abnormalMoney;
            this.tableQuery.confiscateMoney = val.data.confiscateMoney;
            this.tableQuery.totalCount = val.data.payCount;
            this.tableQuery.totalMoney = val.data.payMoney>0 ? val.data.payMoney/100:0;
          }
          if (val.data.pageRes.records.length<=0){
            this.tableQuery.totalCount = 0;
            this.tableQuery.totalMoney = 0;
          }
          this.tableQuery.total = val.data.pageRes.total;
          this.tableData = val.data.pageRes.records;
        }
      })
    },
    recordMonthSummary(){
      this.query.loading = true;
      if (this.query.yearMonth){
        const [year, month] = this.query.yearMonth.split('-');
        this.query.year = year;
        this.query.month = month;
      }else {
        this.query.year = null;
        this.query.month = null;
      }
      recordMonthSummary(this.query).then(val=>{
        this.query.loading = false;
        if (val.code == 200){
          this.lineChartData.noCheckMoney = val.data.noCheckMoney;
          this.lineChartData.normalMoney = val.data.normalMoney;
          this.lineChartData.abnormalMoney = val.data.abnormalMoney;
          this.lineChartData.confiscateMoney = val.data.confiscateMoney;


          this.lineChartData.totalMoney = val.data.payMoney > 0 ? val.data.payMoney/100:0;
          this.lineChartData.totalCount = val.data.payCount;
          this.lineChartData.day = val.data.list.map(item => item.day);
          this.lineChartData.money = val.data.list.map(item => item.payMoney);
          this.lineChartData.count = val.data.list.map(item => item.payCount);
          this.setOption();
        }
      })
    },
    setOption() {
      const money = this.lineChartData.money.map(value => value / 100);
      const maxValue = Math.max(...money);
      const interval = Math.ceil(maxValue / 8); // 分成8个左右的刻度
      let myChart = echarts.init(this.$refs.lineColumnar);
      myChart.off('click')
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: ['金额', '单量']
        },
        xAxis: [
          {
            type: 'category',
            data: this.lineChartData.day,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            // 单量轴自动计算最大值（避免硬编码）
            max: 'dataMax',
            interval: 8,
            axisLabel: {
              formatter: '{value}单'
            }
          },
          {
            type: 'value',
            min: 0,
            // 金额轴自动计算最大值（关键修复）
            max: 'dataMax',
            // 自动计算间隔（避免硬编码5）
            interval: interval,
            axisLabel: {
              formatter: '{value}￥'
            }
          }
        ],
        series: [
          {
            name: '单量',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              formatter: params => (params.value )+ '单',
              // 标签不重叠策略
              avoidLabelOverlap: true,
              // 隔一个显示一个（根据数据密度调整）
              interval: 'auto'
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + '单';
              }
            },

            data: this.lineChartData.count
          },
          {
            name: '金额',
            type: 'line',
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top',
              formatter: params => params.value+ '元',
              // 标签不重叠策略
              avoidLabelOverlap: true,
              // 隔一个显示一个（根据数据密度调整）
              interval: 'auto'
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + '￥';
              }
            },
            data: money
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
.total{
  font-size: 14px;
  text-align: center;
  width: 30%;
  margin: 20px;
  padding:18px 20px 20px 20px;
  border-radius: 12px;
  background-color: white;
}
.line-chart{
   height: 580px;
  background-color: #F5F7FA;
  border-radius: 16px;
  margin: 10px 20px;
}
.table {
  width: 100%;
  font-size: 14px;
  text-align: left;
  border-radius: 12px;
}
.el-cascader__tags {
  display: inline-flex;
  margin-right: 60px;
  flex-wrap: nowrap;
}
</style>